import { useDispatch } from 'react-redux'
import {
  Image,
  Stack,
  Text
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import { SingleButton } from 'common/Buttons'

export const VerifyLinkPage = ({
  setUserSectionPage,
  verifyPageText
}) => {
  const dispatch = useDispatch()

  return (
    <Stack direction="column" spacing="32px">
      <Image
        boxSize="72px"
        objectFit="cover"
        src={ImagesPng.Logo}
        alt="Logo"
        borderRadius="full"
        margin="auto"
      />

      <Text textAlign="center" fontSize="16px">
        {verifyPageText}
      </Text>

      <SingleButton click={() => dispatch(setUserSectionPage(null))} text="Back to Sign in" />
    </Stack>
  )
}
